import { BillDetails, getAccountBills } from "../../../api/services";
import { useQuery } from "react-query";
import { usePagination } from "../../../hooks";
import { usePaginationResult, PAGE_SIZE } from "../../../hooks/usePagination";

export type useAccountBillsResult = usePaginationResult<BillDetails>;

export const useAccountBills = (
  accountNumber: string,
): useAccountBillsResult => {
  const { setPage, page } = usePagination("accounts/bills");

  const { isFetching, status, error, data } = useQuery(
    ["accounts/bills", { page, size: PAGE_SIZE, accountNumber }],
    getAccountBills,
  );

  return {
    //Pagination Handlers
    page,
    setPage,
    pageSize: PAGE_SIZE,
    // Request Handlers
    status,
    isFetching,
    error,
    data: data?.results,
    count: data?.totalCount,
  };
};
